import React, { useState } from "react";
import { FaPaperPlane } from "react-icons/fa"; // Icon send
import "./whatApp.css";

const WhatApp = ({ isOpen, setIsOpen }) => {
  const phoneNumber = "6287870701099";

  const handleWhatsAppClick = () => {
    setIsOpen(true); // Buka popup
  };

  const handleSendMessage = () => {
    const defaultMessage = "Halo, ada yang bisa saya bantu?";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;
    window.open(whatsappUrl, "_blank");
    setIsOpen(false); // Tutup popup setelah mengirim pesan
  };

  return (
    <div>
      {/* WhatsApp Floating Button */}
      <div className="whatapp-logo" onClick={handleWhatsAppClick}>
        <img src="OIP.png" alt="WhatsApp Logo" className="logo" />
      </div>

      {/* Popup Chat */}
      {isOpen && (
        <div className="whatsapp-popup">
          <div className="popup-header">
            <div className="profile-pic">
              <img src="marsl.png" alt="Mars Acme Logo" />
            </div>
            <span className="company-names">Mars Acme Perkasa</span>
            <button className="close-btn" onClick={() => setIsOpen(false)}>✖</button>
          </div>
          <div className="chat-container">
            <div className="chat-bubble">
              Halo, ada yang bisa saya bantu?🤖
            </div>
            <button className="send-btn" onClick={handleSendMessage}>
              <FaPaperPlane />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default WhatApp;